import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const NorthIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M 9 5 C 9 7.207031 7.210938 9 5 9 C 2.789062 9 1 7.207031 1 5 C 1 2.789062 2.789062 1 5 1 C 7.210938 1 9 2.789062 9 5 Z M 9 5" />
            <path
                d="M 8.246094 2.664062 C 8.679688 3.261719 8.933594 3.96875 8.988281 4.707031 C 9.042969 5.441406 8.894531 6.179688 8.554688 6.835938 C 8.214844 7.488281 7.703125 8.039062 7.070312 8.421875 C 6.441406 8.804688 5.714844 9.003906 4.976562 9 C 4.238281 8.996094 3.515625 8.789062 2.890625 8.398438 C 2.261719 8.007812 1.757812 7.453125 1.425781 6.792969 C 1.09375 6.132812 0.953125 5.394531 1.015625 4.660156 C 1.078125 3.925781 1.339844 3.222656 1.777344 2.628906 L 5 5 Z M 8.246094 2.664062"
                fill="#ededee"
            />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const NorthIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M 9 5 C 9 7.207031 7.210938 9 5 9 C 2.789062 9 1 7.207031 1 5 C 1 2.789062 2.789062 1 5 1 C 7.210938 1 9 2.789062 9 5 Z M 9 5" />
            <path
                d="M 8.246094 2.664062 C 8.679688 3.261719 8.933594 3.96875 8.988281 4.707031 C 9.042969 5.441406 8.894531 6.179688 8.554688 6.835938 C 8.214844 7.488281 7.703125 8.039062 7.070312 8.421875 C 6.441406 8.804688 5.714844 9.003906 4.976562 9 C 4.238281 8.996094 3.515625 8.789062 2.890625 8.398438 C 2.261719 8.007812 1.757812 7.453125 1.425781 6.792969 C 1.09375 6.132812 0.953125 5.394531 1.015625 4.660156 C 1.078125 3.925781 1.339844 3.222656 1.777344 2.628906 L 5 5 Z M 8.246094 2.664062"
                fill="#ededee"
            />
        </SvgIcon>
    );
};
